import { BlueHeader, HeaderBack } from './ScreenShell';
import { LegalText } from './LegalText';
import { OFFER_TEXT } from '../screens/auth/offerText';
import { CONSENT_TEXT } from '../screens/auth/consentText';

const DOCS = {
  offer: { title: 'Публичная оферта', text: OFFER_TEXT },
  consent: { title: 'Согласие на обработку персональных данных', text: CONSENT_TEXT },
} as const;

export type LegalDoc = keyof typeof DOCS;

/** Полный текст юридического документа поверх auth-экранов (роутер там ещё
 *  не смонтирован — App.tsx отдаёт эти экраны ранними return'ами). */
export function LegalDocOverlay({ doc, onClose }: { doc: LegalDoc; onClose: () => void }) {
  const { title, text } = DOCS[doc];
  return (
    <div className="terms-page">
      <BlueHeader>
        <div className="bhead-top" style={{ marginBottom: 0 }}>
          <HeaderBack onClick={onClose} />
          <div className="bhead-title bhead-title--sm" style={{ flex: 1 }}>
            {title}
          </div>
        </div>
      </BlueHeader>

      <div className="content">
        <div className="terms-card terms-card--doc">
          <LegalText text={text} />
        </div>
        <button className="btn" onClick={onClose}>
          Закрыть
        </button>
        <div style={{ height: 24 }} />
      </div>
    </div>
  );
}
